import React, { Component } from 'react';
import { Route, Switch } from 'react-router-dom';
import ReactResizeDetector from 'react-resize-detector';
import Template from './Template.jsx';
import { checkURLParams } from '../helpers/routes';
import _ from 'lodash';

class Routes extends Component {
  state = {
    isTop: true
  };

  componentDidMount () {
    document.addEventListener('scroll', this.handleScroll);
    checkURLParams();
  }

  handleScroll = () => {
    const isTop = window.scrollY < 50;
    if (isTop !== this.state.isTop) {
      this.setState({ isTop });
    }
  };

  render () {
    const isSafari = /Safari/.test(navigator.userAgent) && /Apple Computer/.test(navigator.vendor);
    const isIE11 = !!window.MSInputMethodContext && !!document.documentMode;
    let myProps = _.clone(this.props);
    let wrapperClasses = '';

    myProps.pathname = window.location.pathname;

    if (isSafari) wrapperClasses += ' safari';
    if (!this.state.isTop) wrapperClasses += ' scroll';
    if (isIE11) wrapperClasses += ' ie';

    return (
      <div className={wrapperClasses}>
        <ReactResizeDetector handleWidth handleHeight onResize={this.onResize}>
          <Switch>
            <Route path='/' exact render={(props) => <Template {...myProps} />} />
            <Route path='/:route/:subroute' render={(props) => <Template {...myProps} />} />
            <Route path='/:route' render={(props) => <Template {...myProps} />} />
          </Switch>
        </ReactResizeDetector>
      </div>
    );
  }
}

export default Routes;


// WEBPACK FOOTER //
// ./src/containers/Routes.jsx